class StickyAtc extends HTMLElement {
  connectedCallback() {
    this.realButton = document.querySelector('.product-form__submit');
    this.stickyButton = this.querySelector('[data-sticky-add]');
    this.priceEl = this.querySelector('[data-sticky-price]');
    if (!this.realButton || !this.stickyButton) return;

    // Clicking the sticky button just triggers the real add-to-cart button,
    // so it uses the exact same form, variant and AJAX cart behaviour.
    this.stickyButton.addEventListener('click', () => this.realButton.click());

    // Show the bar only once the real button has scrolled out of view.
    this.observer = new IntersectionObserver(
      (entries) => {
        const visible = entries[0].isIntersecting;
        this.classList.toggle('is-visible', !visible);
        this.setAttribute('aria-hidden', visible ? 'true' : 'false');
      },
      { rootMargin: '0px 0px -20px 0px' }
    );
    this.observer.observe(this.realButton);

    // Keep the sticky price and disabled state in sync with the main product form.
    this.mainPrice = document.querySelector('.product__info-container .price');
    if (this.mainPrice) {
      this.priceObserver = new MutationObserver(() => this.sync());
      this.priceObserver.observe(this.mainPrice, { childList: true, subtree: true, characterData: true });
    }
    this.buttonObserver = new MutationObserver(() => this.syncButton());
    this.buttonObserver.observe(this.realButton, { attributes: true, attributeFilter: ['disabled'] });
  }

  sync() {
    if (!this.priceEl || !this.mainPrice) return;
    const sale = this.mainPrice.querySelector('.price__sale .price-item--sale');
    const regular = this.mainPrice.querySelector('.price-item--regular');
    const source = sale && sale.textContent.trim() ? sale : regular;
    if (source && source.textContent.trim()) this.priceEl.textContent = source.textContent.trim();
    this.syncButton();
  }

  syncButton() {
    if (!this.stickyButton || !this.realButton) return;
    this.stickyButton.disabled = this.realButton.disabled;
  }

  disconnectedCallback() {
    this.observer && this.observer.disconnect();
    this.priceObserver && this.priceObserver.disconnect();
    this.buttonObserver && this.buttonObserver.disconnect();
  }
}

if (!customElements.get('sticky-atc')) {
  customElements.define('sticky-atc', StickyAtc);
}
